export const TAB_MES_SELECIONADO_DEFAULT = "01";
export const ESPACO_VAZIO = '\u00A0';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_FORMAT_BR = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DATE_TIME_FORMAT_BR = 'DD/MM/YYYY HH:mm:ss';
export const DATE_TIME_ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';
